import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "xwide12": "user-bag-page-by-username-2dc74d76-xwide12-WXUgJq",
  "tinyOffset0": "user-bag-page-by-username-2dc74d76-tinyOffset0-WXUgJq",
  "armstrongGridContainer": "user-bag-page-by-username-2dc74d76-armstrongGridContainer-WXUgJq",
  "defaultOffset5": "user-bag-page-by-username-2dc74d76-defaultOffset5-WXUgJq",
  "wideGridContainer": "user-bag-page-by-username-2dc74d76-wideGridContainer-WXUgJq",
  "xwideOffset11": "user-bag-page-by-username-2dc74d76-xwideOffset11-WXUgJq",
  "tinyOffset9": "user-bag-page-by-username-2dc74d76-tinyOffset9-WXUgJq",
  "xwideOffset10": "user-bag-page-by-username-2dc74d76-xwideOffset10-WXUgJq",
  "tiny11": "user-bag-page-by-username-2dc74d76-tiny11-WXUgJq",
  "confined0": "user-bag-page-by-username-2dc74d76-confined0-WXUgJq",
  "tiny8": "user-bag-page-by-username-2dc74d76-tiny8-WXUgJq",
  "xwide2": "user-bag-page-by-username-2dc74d76-xwide2-WXUgJq",
  "xwideOffset8": "user-bag-page-by-username-2dc74d76-xwideOffset8-WXUgJq",
  "defaultOffset10": "user-bag-page-by-username-2dc74d76-defaultOffset10-WXUgJq",
  "wideOffset2": "user-bag-page-by-username-2dc74d76-wideOffset2-WXUgJq",
  "confinedOffset3": "user-bag-page-by-username-2dc74d76-confinedOffset3-WXUgJq",
  "confinedOffset5": "user-bag-page-by-username-2dc74d76-confinedOffset5-WXUgJq",
  "xwideOffset7": "user-bag-page-by-username-2dc74d76-xwideOffset7-WXUgJq",
  "confined7": "user-bag-page-by-username-2dc74d76-confined7-WXUgJq",
  "wideOffset3": "user-bag-page-by-username-2dc74d76-wideOffset3-WXUgJq",
  "wide9": "user-bag-page-by-username-2dc74d76-wide9-WXUgJq",
  "wideOffset0": "user-bag-page-by-username-2dc74d76-wideOffset0-WXUgJq",
  "xwideOffset9": "user-bag-page-by-username-2dc74d76-xwideOffset9-WXUgJq",
  "wide3": "user-bag-page-by-username-2dc74d76-wide3-WXUgJq",
  "wideOffset5": "user-bag-page-by-username-2dc74d76-wideOffset5-WXUgJq",
  "default11": "user-bag-page-by-username-2dc74d76-default11-WXUgJq",
  "defaultOffset7": "user-bag-page-by-username-2dc74d76-defaultOffset7-WXUgJq",
  "wide5": "user-bag-page-by-username-2dc74d76-wide5-WXUgJq",
  "confinedOffset11": "user-bag-page-by-username-2dc74d76-confinedOffset11-WXUgJq",
  "tiny0": "user-bag-page-by-username-2dc74d76-tiny0-WXUgJq",
  "wideOffset6": "user-bag-page-by-username-2dc74d76-wideOffset6-WXUgJq",
  "wideOffset9": "user-bag-page-by-username-2dc74d76-wideOffset9-WXUgJq",
  "default6": "user-bag-page-by-username-2dc74d76-default6-WXUgJq",
  "xwide10": "user-bag-page-by-username-2dc74d76-xwide10-WXUgJq",
  "confinedOffset1": "user-bag-page-by-username-2dc74d76-confinedOffset1-WXUgJq",
  "confined10": "user-bag-page-by-username-2dc74d76-confined10-WXUgJq",
  "wideOffset11": "user-bag-page-by-username-2dc74d76-wideOffset11-WXUgJq",
  "confined8": "user-bag-page-by-username-2dc74d76-confined8-WXUgJq",
  "xwideOffset6": "user-bag-page-by-username-2dc74d76-xwideOffset6-WXUgJq",
  "default12": "user-bag-page-by-username-2dc74d76-default12-WXUgJq",
  "defaultOffset11": "user-bag-page-by-username-2dc74d76-defaultOffset11-WXUgJq",
  "xwide4": "user-bag-page-by-username-2dc74d76-xwide4-WXUgJq",
  "default10": "user-bag-page-by-username-2dc74d76-default10-WXUgJq",
  "wide2": "user-bag-page-by-username-2dc74d76-wide2-WXUgJq",
  "default1": "user-bag-page-by-username-2dc74d76-default1-WXUgJq",
  "tinyOffset10": "user-bag-page-by-username-2dc74d76-tinyOffset10-WXUgJq",
  "tinyOffset4": "user-bag-page-by-username-2dc74d76-tinyOffset4-WXUgJq",
  "tinyOffset11": "user-bag-page-by-username-2dc74d76-tinyOffset11-WXUgJq",
  "defaultOffset6": "user-bag-page-by-username-2dc74d76-defaultOffset6-WXUgJq",
  "default9": "user-bag-page-by-username-2dc74d76-default9-WXUgJq",
  "tinyOffset2": "user-bag-page-by-username-2dc74d76-tinyOffset2-WXUgJq",
  "xwideOffset3": "user-bag-page-by-username-2dc74d76-xwideOffset3-WXUgJq",
  "xwideOffset1": "user-bag-page-by-username-2dc74d76-xwideOffset1-WXUgJq",
  "tiny5": "user-bag-page-by-username-2dc74d76-tiny5-WXUgJq",
  "tinyOffset8": "user-bag-page-by-username-2dc74d76-tinyOffset8-WXUgJq",
  "default2": "user-bag-page-by-username-2dc74d76-default2-WXUgJq",
  "defaultOffset8": "user-bag-page-by-username-2dc74d76-defaultOffset8-WXUgJq",
  "grid": "user-bag-page-by-username-2dc74d76-grid-WXUgJq",
  "wide7": "user-bag-page-by-username-2dc74d76-wide7-WXUgJq",
  "defaultOffset1": "user-bag-page-by-username-2dc74d76-defaultOffset1-WXUgJq",
  "confinedOffset6": "user-bag-page-by-username-2dc74d76-confinedOffset6-WXUgJq",
  "confined2": "user-bag-page-by-username-2dc74d76-confined2-WXUgJq",
  "default4": "user-bag-page-by-username-2dc74d76-default4-WXUgJq",
  "confined12": "user-bag-page-by-username-2dc74d76-confined12-WXUgJq",
  "defaultOffset9": "user-bag-page-by-username-2dc74d76-defaultOffset9-WXUgJq",
  "confinedOffset8": "user-bag-page-by-username-2dc74d76-confinedOffset8-WXUgJq",
  "col": "user-bag-page-by-username-2dc74d76-col-WXUgJq",
  "xwide7": "user-bag-page-by-username-2dc74d76-xwide7-WXUgJq",
  "default5": "user-bag-page-by-username-2dc74d76-default5-WXUgJq",
  "defaultOffset4": "user-bag-page-by-username-2dc74d76-defaultOffset4-WXUgJq",
  "tiny9": "user-bag-page-by-username-2dc74d76-tiny9-WXUgJq",
  "tinyOffset5": "user-bag-page-by-username-2dc74d76-tinyOffset5-WXUgJq",
  "tinyOffset7": "user-bag-page-by-username-2dc74d76-tinyOffset7-WXUgJq",
  "standardGridContainer": "user-bag-page-by-username-2dc74d76-standardGridContainer-WXUgJq",
  "wide1": "user-bag-page-by-username-2dc74d76-wide1-WXUgJq",
  "wideOffset1": "user-bag-page-by-username-2dc74d76-wideOffset1-WXUgJq",
  "xwideOffset2": "user-bag-page-by-username-2dc74d76-xwideOffset2-WXUgJq",
  "default3": "user-bag-page-by-username-2dc74d76-default3-WXUgJq",
  "tiny4": "user-bag-page-by-username-2dc74d76-tiny4-WXUgJq",
  "wideOffset7": "user-bag-page-by-username-2dc74d76-wideOffset7-WXUgJq",
  "confined11": "user-bag-page-by-username-2dc74d76-confined11-WXUgJq",
  "xwide3": "user-bag-page-by-username-2dc74d76-xwide3-WXUgJq",
  "default7": "user-bag-page-by-username-2dc74d76-default7-WXUgJq",
  "tiny6": "user-bag-page-by-username-2dc74d76-tiny6-WXUgJq",
  "tiny2": "user-bag-page-by-username-2dc74d76-tiny2-WXUgJq",
  "tiny10": "user-bag-page-by-username-2dc74d76-tiny10-WXUgJq",
  "confinedOffset0": "user-bag-page-by-username-2dc74d76-confinedOffset0-WXUgJq",
  "confinedOffset4": "user-bag-page-by-username-2dc74d76-confinedOffset4-WXUgJq",
  "wide10": "user-bag-page-by-username-2dc74d76-wide10-WXUgJq",
  "tiny1": "user-bag-page-by-username-2dc74d76-tiny1-WXUgJq",
  "defaultOffset3": "user-bag-page-by-username-2dc74d76-defaultOffset3-WXUgJq",
  "tiny7": "user-bag-page-by-username-2dc74d76-tiny7-WXUgJq",
  "tiny12": "user-bag-page-by-username-2dc74d76-tiny12-WXUgJq",
  "gridContainer": "user-bag-page-by-username-2dc74d76-gridContainer-WXUgJq",
  "confined4": "user-bag-page-by-username-2dc74d76-confined4-WXUgJq",
  "confined1": "user-bag-page-by-username-2dc74d76-confined1-WXUgJq",
  "confinedOffset10": "user-bag-page-by-username-2dc74d76-confinedOffset10-WXUgJq",
  "confined6": "user-bag-page-by-username-2dc74d76-confined6-WXUgJq",
  "tiny3": "user-bag-page-by-username-2dc74d76-tiny3-WXUgJq",
  "wide4": "user-bag-page-by-username-2dc74d76-wide4-WXUgJq",
  "confinedOffset2": "user-bag-page-by-username-2dc74d76-confinedOffset2-WXUgJq",
  "wide11": "user-bag-page-by-username-2dc74d76-wide11-WXUgJq",
  "xwide1": "user-bag-page-by-username-2dc74d76-xwide1-WXUgJq",
  "row": "user-bag-page-by-username-2dc74d76-row-WXUgJq",
  "wideOffset4": "user-bag-page-by-username-2dc74d76-wideOffset4-WXUgJq",
  "xwide6": "user-bag-page-by-username-2dc74d76-xwide6-WXUgJq",
  "confinedOffset9": "user-bag-page-by-username-2dc74d76-confinedOffset9-WXUgJq",
  "tinyOffset3": "user-bag-page-by-username-2dc74d76-tinyOffset3-WXUgJq",
  "xwide0": "user-bag-page-by-username-2dc74d76-xwide0-WXUgJq",
  "confinedOffset7": "user-bag-page-by-username-2dc74d76-confinedOffset7-WXUgJq",
  "tinyOffset1": "user-bag-page-by-username-2dc74d76-tinyOffset1-WXUgJq",
  "default0": "user-bag-page-by-username-2dc74d76-default0-WXUgJq",
  "xwideOffset4": "user-bag-page-by-username-2dc74d76-xwideOffset4-WXUgJq",
  "wide12": "user-bag-page-by-username-2dc74d76-wide12-WXUgJq",
  "xwideOffset5": "user-bag-page-by-username-2dc74d76-xwideOffset5-WXUgJq",
  "wideOffset8": "user-bag-page-by-username-2dc74d76-wideOffset8-WXUgJq",
  "xwide11": "user-bag-page-by-username-2dc74d76-xwide11-WXUgJq",
  "xwide5": "user-bag-page-by-username-2dc74d76-xwide5-WXUgJq",
  "xwide8": "user-bag-page-by-username-2dc74d76-xwide8-WXUgJq",
  "wide6": "user-bag-page-by-username-2dc74d76-wide6-WXUgJq",
  "confined3": "user-bag-page-by-username-2dc74d76-confined3-WXUgJq",
  "wide8": "user-bag-page-by-username-2dc74d76-wide8-WXUgJq",
  "confined9": "user-bag-page-by-username-2dc74d76-confined9-WXUgJq",
  "confined5": "user-bag-page-by-username-2dc74d76-confined5-WXUgJq",
  "tinyOffset6": "user-bag-page-by-username-2dc74d76-tinyOffset6-WXUgJq",
  "wide0": "user-bag-page-by-username-2dc74d76-wide0-WXUgJq",
  "wideOffset10": "user-bag-page-by-username-2dc74d76-wideOffset10-WXUgJq",
  "default8": "user-bag-page-by-username-2dc74d76-default8-WXUgJq",
  "defaultOffset2": "user-bag-page-by-username-2dc74d76-defaultOffset2-WXUgJq",
  "xwideOffset0": "user-bag-page-by-username-2dc74d76-xwideOffset0-WXUgJq",
  "xwide9": "user-bag-page-by-username-2dc74d76-xwide9-WXUgJq"
};